import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../utils/immutable";

interface IAction {
  type: any;
  payload: any;
}

const ACTION_HANDLERS = {
  [actionTypes.LOGGED_USER_SUCCESS]: (state: any, action: any) =>
    immutableSet(["user"], action.payload, state),
  [actionTypes.CHANGE_LANGUAGE]: (state: any, action: any) =>
    immutableSet(["language"], action.payload, state),
  [actionTypes.TIME_EXPIRED]: (state: any, action: any) =>
    immutableSet(["loginExpired"], action.payload, state),
  [actionTypes.SET_TRIGGER_ERROR_MODAL]: (state: any, action: any) =>
    immutableSet(["modalTrigger"], action.payload, state),
  [actionTypes.SET_FLOAT_SPINNER]: (state: any, action: any) =>
    immutableSet(["floatSpinner"], action.payload, state),
  [actionTypes.SET_ACCESS_FROM_INTERNET]: (state: any, action: any) =>
    immutableSet(["accessFromInternet"], action.payload, state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    immutableSet(["modalTrigger"], false, state);
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
